import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, SkeletonLine } from "@opensea/ui-kit";
import { range } from "es-toolkit/math";
export function CollectionMetadataChipsSkeleton(t0) {
  const $ = _c(7);
  const {
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "on-background" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = classNames("gap-2", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== variant) {
    t3 = range(3).map(index => <SkeletonLine className="h-[18px] w-24 rounded" key={index.toString()} variant={variant} />);
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <Flex className={t2}>{t3}</Flex>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}